import { useEffect, useState } from "react";
import { ClipboardList } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Panel } from "@/components/crm/Badges";
import { TasksBlock } from "@/components/crm/lead/TasksBlock";
import { NotesBlock } from "@/components/crm/lead/NotesBlock";

export const FollowUpPanel = ({ data, leadId, onUpdate, reload }) => {
  const { lead } = data;
  const [next, setNext] = useState({ next_action: "", next_action_date: "" });
  useEffect(() => setNext({ next_action: lead.next_action || "", next_action_date: lead.next_action_date || "" }), [lead.next_action, lead.next_action_date]);
  const dirty = next.next_action !== (lead.next_action || "") || next.next_action_date !== (lead.next_action_date || "");

  return (
    <Panel title="Seguimiento" icon={ClipboardList} testid="lead-followup-panel">
      <div className="rounded-xl bg-[#F5F7FA] p-4">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Próxima acción</p>
        <div className="mt-2 flex flex-col gap-2 sm:flex-row">
          <Input value={next.next_action} onChange={(e) => setNext((s) => ({ ...s, next_action: e.target.value }))} placeholder="Ej. Llamar para confirmar cita"
                 className="h-10 flex-1 rounded-xl bg-white" data-testid="next-action-input" />
          <Input type="date" value={next.next_action_date} onChange={(e) => setNext((s) => ({ ...s, next_action_date: e.target.value }))}
                 className="h-10 rounded-xl bg-white sm:w-44" data-testid="next-action-date-input" />
          <Button disabled={!dirty} onClick={() => onUpdate({ next_action: next.next_action || null, next_action_date: next.next_action_date || null })}
                  className="h-10 rounded-xl bg-[#1E6FD9]" data-testid="save-next-action-button">Guardar</Button>
        </div>
      </div>
      <div className="mt-6 grid gap-6 lg:grid-cols-2">
        <TasksBlock tasks={data.tasks} leadId={leadId} reload={reload} />
        <NotesBlock notes={data.notes} leadId={leadId} reload={reload} />
      </div>
    </Panel>
  );
};
